(function () {
  // Placement is done in Liquid (sections/main-article.liquid): the TOC is rendered
  // twice — sidebar for desktop, below the author row for mobile — with anchor links
  // to the article's own <h2>s (ids stamped server-side), and the promo tiles are
  // injected into the article body server-side. CSS shows one copy per breakpoint.
  // Here: collapse toggle, hide an empty TOC, mark the heading currently in view, and
  // on mobile fold the TOC away after a tap so it does not sit over the target heading.
  var MOBILE_QUERY = '(max-width: 1023px)';

  function setCollapsed(toc, collapsed) {
    var toggle = toc.querySelector('[data-toc-toggle]');
    toc.setAttribute('data-collapsed', collapsed ? 'true' : 'false');
    if (toggle) toggle.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
  }

  function init(toc) {
    var list = toc.querySelector('[data-toc-list]');
    if (list && list.children.length === 0) {
      toc.hidden = true;
      return;
    }

    var toggle = toc.querySelector('[data-toc-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        setCollapsed(toc, toc.getAttribute('data-collapsed') !== 'true');
      });
    }

    // Smooth-scroll to the heading (scrollIntoView honours the heading's
    // scroll-margin-top) and keep the hash in the URL so the anchor is shareable.
    toc.addEventListener('click', function (event) {
      var link = event.target.closest('[data-toc-anchor]');
      if (!link) return;
      var heading = document.getElementById(link.getAttribute('data-toc-anchor'));
      if (!heading) return;

      event.preventDefault();
      var isMobile = toc.classList.contains('article-toc--mobile') && window.matchMedia(MOBILE_QUERY).matches;
      if (isMobile) setCollapsed(toc, true);

      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      heading.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', '#' + heading.id);
    });
  }

  // Highlight the TOC entry for the heading nearest the top of the viewport. One
  // observer drives both TOC copies; the "active" heading is the last one whose top
  // has scrolled past the header offset, so long sections stay lit while reading.
  function trackActiveHeading() {
    var links = document.querySelectorAll('[data-toc-anchor]');
    if (!links.length || !('IntersectionObserver' in window)) return;

    var headings = [];
    var seen = {};
    links.forEach(function (link) {
      var id = link.getAttribute('data-toc-anchor');
      if (seen[id]) return;
      var heading = document.getElementById(id);
      if (heading) {
        seen[id] = true;
        headings.push(heading);
      }
    });
    if (!headings.length) return;

    var offset = 120; // matches scroll-margin-top on .article-content h2, plus a little
    var current = null;

    function setActive(heading) {
      if (heading === current) return;
      current = heading;
      var id = heading ? heading.id : null;
      links.forEach(function (link) {
        var on = link.getAttribute('data-toc-anchor') === id;
        link.classList.toggle('is-active', on);
        if (on) link.setAttribute('aria-current', 'true');
        else link.removeAttribute('aria-current');
      });
    }

    function update() {
      var active = null;
      for (var i = 0; i < headings.length; i++) {
        if (headings[i].getBoundingClientRect().top - offset <= 0) active = headings[i];
        else break;
      }
      setActive(active);
    }

    // Recompute whenever a heading crosses the offset line; the observer fires on
    // scroll only for the headings that moved, so this stays cheap.
    var observer = new IntersectionObserver(update, {
      rootMargin: '-' + offset + 'px 0px 0px 0px',
      threshold: [0, 1],
    });
    headings.forEach(function (heading) {
      observer.observe(heading);
    });
    update();
  }

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {
    document.querySelectorAll('[data-article-toc]').forEach(init);
    trackActiveHeading();
  });
})();
